<template>
    <v-menu class="header-user" offsetY open-on-hover>
        <template v-slot:activator="{ on }">
            <div class="header-action" v-on="on">
                <action class="toggle" name="main">{{ name ? name : initialName }}</action>
            </div>
        </template>
        <v-list>
            <v-list-item>
                <v-list-item-title class="link">
                    <a class="url" href="/espace-client">Mon espace</a>
                </v-list-item-title>
            </v-list-item>
            <v-list-item>
                <v-list-item-title class="link">
                    <a class="url" href="/espace-client/mon-compte">Mon compte</a>
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="permission === 'adm_sys'">
                <v-list-item-title class="link">
                    <a class="url" :href="boUrl" target="_blank">Backoffice</a>
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="permission === 'adm_sys'">
                <v-list-item-title class="link">
                    <a class="url" :href="wpUrl" target="_blank">Wordpress</a>
                </v-list-item-title>
            </v-list-item>
            <v-list-item>
                <v-list-item-title class="link" @click="logout"> Déconnexion </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { Services } from "src/services/Services";
import { EventBus } from "src/bus/eventBus";

export default {
    props: ["initialName", "permission"],
    data: () => ({
        value: false,
        name: null,
        boUrl: window.process.env.APP_DIODE_BO_URL,
        wpUrl: window.process.env.APP_DIODE_WP_BO_URL,
    }),
    mounted() {
        EventBus.$on("user:updated", user => {
            if (user) {
                this.name = user.fullName;
            }
        });
    },
    methods: {
        logout() {
            Services.api.auth.logout();
            location.href = "/";
        },
    },
};
</script>

<style lang="sass" scoped>
.link, .url
    color: black
    cursor: pointer
    text-decoration: none

.v-list-item:hover
    background: $color-background

@media print
    .header-action,
    .header-user
        display: none
</style>
